// Resize + compress an image File before upload.
// - Long edge capped at MAX_DIM (default 1920) — keeps detail without bloating storage.
// - Re-encoded as JPEG at QUALITY (default 0.85). This also strips EXIF metadata
//   (including GPS coords) since the canvas re-encode doesn't carry it over.
// Returns a Blob ready to upload.
export async function compressImage(file, { maxDim = 1920, quality = 0.85 } = {}) {
  if (!file || !file.type?.startsWith('image/')) {
    throw new Error('Not an image file');
  }

  const img = await loadImage(file);
  const { width, height } = scaleDown(img.width, img.height, maxDim);

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, width, height);

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) return reject(new Error('Image encode failed'));
        resolve(blob);
      },
      'image/jpeg',
      quality,
    );
  });
}

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
  });
}

function scaleDown(w, h, maxDim) {
  if (w <= maxDim && h <= maxDim) return { width: w, height: h };
  const ratio = w > h ? maxDim / w : maxDim / h;
  return { width: Math.round(w * ratio), height: Math.round(h * ratio) };
}
